export const CheckIcon: React.FC<any> = ({
  className,
  width = "9",
  height = "7",
}) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg width="${width}" height="${height}" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 3.45L3.1 5.55L7.65 1" stroke="white" stroke-width="1.4" stroke-linecap="round"/>
        </svg>
    `,
      }}
    />
  );
};
